import { createZustandContext } from '@eluve/stores';

type AppointmentRecordingStatus = {
  isActivelyRecording: boolean;
};

export const {
  StoreProvider: AppointmentRecordingStatusStoreProvider,
  useStore: useAppointmentRecordingStatusStore,
  useStoreApi: useAppointmentRecordingStatusStoreApi,
} = createZustandContext<AppointmentRecordingStatus>();
